import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import Transaction from './Payment/Transaction';
import { goToPage, pages } from '../states/page/actions';
import Warnings from './Warning/Warnings';
import PaymentCancelled from './Warning/PaymentCancelled';
import {
	getApiError,
	getNextPage,
	isEffectiveWarningApplicable,
	isStaticWarning,
	isTransferOrCCPayment,
} from './state/selectors';
import { createEWOutcome, CREATE_OUTCOME_SUCCESS, getPaymentReasons, goToEWWarning } from './state/actions';
import { isBatch } from '../states/batch/selectors';
import CreditDeadlineMissed from '../bacs/components/BacsReview/CreditReviewPage/CreditDeadlineMissed';
import { getBacsDeadlineMissed } from '../states/bacsCredit/selectors';
import { getBacsDeadlineMissed as getBacsDebitDeadlineMissed } from '../states/bacsDebit/selectors';
import { getChapsDeadlineMissed } from '../states/chaps/selectors';
import { hasReadTimeOutError } from '../states/page/selectors';
import ChapsDeadlineMissed from '../chaps/components/ChapsReviewPage/ChapsDeadlineMissed';
import DebitDeadlineMissed from '../bacs/components/BacsReview/DebitReviewPage/DebitDeadlineMissed';
import PaymentTimedOutModal from '../sharedComponents/PaymentTimedOutModal';

const mapState = (state, props) => ({
	nextPage: getNextPage(state),
	isEffectiveWarningApplicable: isEffectiveWarningApplicable(state, props.payType),
	isTransferOrCCPayment: isTransferOrCCPayment(state),
	isStaticWarning: isStaticWarning(state, props.payType),
	isBatch: isBatch(state),
	apiError: getApiError(state),
	deadlineMissed: getBacsDeadlineMissed(state),
	chapsDeadlineMissed: getChapsDeadlineMissed(state),
	backsDebitDeadlineMissed: getBacsDebitDeadlineMissed(state),
	readTimeOutError: hasReadTimeOutError(state),
});

const mapDispatch = (dispatch) => ({
	goToPage: (page) => dispatch(goToPage(page)),
	goToEWWarning: (payType, onContinue) => dispatch(goToEWWarning(payType, onContinue)),
	createEWOutcome: (payType) => dispatch(createEWOutcome(payType)),
	getPaymentReasons: () => dispatch(getPaymentReasons()),
});

export class EffectiveWarningSMEContainer extends Component {
	constructor(props) {
		super(props);
		this.handleTransactionContinue = this.handleTransactionContinue.bind(this);

		if (!props.isStaticWarning) {
			props.getPaymentReasons();
		}
	}

	componentDidMount() {
		const {
			createEWOutcome,
			isBatch,
			listPayType,
			batchPayType,
			isStaticWarning,
			apiError,
			onContinue,
			startPage,
			isEffectiveWarningApplicable,
		} = this.props;

		if (
			apiError &&
			(startPage === pages.EffectiveWarning.paymentReason || startPage === pages.EffectiveWarning.warning)
		) {
			onContinue();
		} else {
			this.props.handlePaymentInReview(true);

			// REFACTOR: Static should use a separate layout container
			if (isStaticWarning && isEffectiveWarningApplicable) {
				const payType = isBatch ? batchPayType : listPayType;
				createEWOutcome(payType).then((response) => {
					if (response.type === CREATE_OUTCOME_SUCCESS) this.handleTransactionContinue();
				});
			}
		}
	}

	componentDidUpdate() {
		const { apiError, onContinue, startPage } = this.props;
		if (apiError && startPage === (pages.EffectiveWarning.paymentReason || pages.EffectiveWarning.warning)) {
			onContinue();
		}
	}

	componentWillUnmount() {
		this.props.handlePaymentInReview(false);
	}

	handleTransactionContinue() {
		const { nextPage, onContinue, isBatch, listPayType, batchPayType, goToEWWarning } = this.props;

		// REFACTOR: evaluate the response of the previous action (createEwOutcome - which should not be in transaction component) action rather than checking the nextPage prop
		if (nextPage === pages.EffectiveWarning.warning) {
			const payType = isBatch ? batchPayType : listPayType;
			goToEWWarning(payType, onContinue);
		} else {
			onContinue();
		}
	}

	render() {
		const {
			startPage,
			onCancel,
			onContinue,
			content,
			isEffectiveWarningApplicable,
			isTransferOrCCPayment,
			isStaticWarning,
			handleRoute,
			deadlineMissed,
			chapsDeadlineMissed,
			backsDebitDeadlineMissed,
		} = this.props;
		// REFACTOR: we should not be rendering this component if these conditions apply - this check should happen in parent!
		if (!isEffectiveWarningApplicable || isTransferOrCCPayment) {
			onContinue();
			return null;
		}
		if (deadlineMissed) {
			return <CreditDeadlineMissed content={content} handleRoute={handleRoute} />;
		} else if (chapsDeadlineMissed) {
			return <ChapsDeadlineMissed content={content} handleRoute={handleRoute} />;
		} else if (backsDebitDeadlineMissed) {
			return <DebitDeadlineMissed content={content} handleRoute={handleRoute} />;
		}

		// REFACTOR: startPage should be renamed to ewPage and should come from the ew reducer not passed as a prop
		// REFACTOR: Component names should match the page names
		switch (startPage) {
			case pages.EffectiveWarning.paymentReason:
				if (isStaticWarning) {
					return <Loader isOpen />;
				}
				return (
					<div>
						<PaymentTimedOutModal handleRoute={handleRoute} />
						<Transaction {...this.props} onContinue={this.handleTransactionContinue} />
					</div>
				);
			case pages.EffectiveWarning.warning:
			case pages.EffectiveWarning.approverWarning: // REFACTOR: Can remove this page?
				return (
					<div>
						<PaymentTimedOutModal handleRoute={handleRoute} />
						<Warnings {...this.props} />
					</div>
				);
			case pages.EffectiveWarning.paymentCancelled:
				return <PaymentCancelled onAction={onCancel} handleRoute={handleRoute} />;
			default:
				return null;
		}
	}
}

EffectiveWarningSMEContainer.propTypes = {
	startPage: PropTypes.string,
	onCancel: PropTypes.func,
	handlePaymentInReview: PropTypes.func,
	nextPage: PropTypes.string,
	goToPage: PropTypes.func,
	onContinue: PropTypes.func,
	isBatch: PropTypes.bool,
	payType: PropTypes.string,
	listPayType: PropTypes.string,
	batchPayType: PropTypes.string,
	goToEWWarning: PropTypes.func.isRequired,
	isEffectiveWarningApplicable: PropTypes.bool,
	isTransferOrCCPayment: PropTypes.bool,
	createEWOutcome: PropTypes.func,
	isStaticWarning: PropTypes.func,
	apiError: PropTypes.bool,
	getPaymentReasons: PropTypes.func,
	handleRoute: PropTypes.func,
	readTimeOutError: PropTypes.bool,
};

export default connect(mapState, mapDispatch)(EffectiveWarningSMEContainer);
